export const SEARCH_HISTORY_MAX_ITEMS_COUNT = isNaN(Number(process.env.REACT_APP_SEARCH_HISTORY_SIZE))
    ? 1000
    : Number(process.env.REACT_APP_SEARCH_HISTORY_SIZE);
export const COUNT_OF_DISPLAYING_SEARCH_SUGGESTIONS = 3;
